import { type ReactNode } from "react"

import {
  type Resource,
  RESOURCES,
  USER_ACTIONS,
  type UserAction,
} from "#customTypes/composedTypes/authTypes"
import useHasPermission from "#hooks/newHooks/useHasPermission"

interface ProtectedComponentProps {
  resource: Resource
  action: UserAction
  children: ReactNode
  fallback?: ReactNode
}

export const ProtectedComponent = ({
  resource,
  action,
  children,
  fallback = null,
}: ProtectedComponentProps) => {
  const canSee = useHasPermission(resource, action)

  if (!canSee) {
    return fallback
  }

  return children
}

// Convenience component for login protection
interface LoginProtectedProps {
  children: ReactNode
  fallback?: ReactNode
}

export const LoginProtected = ({
  children,
  fallback = <div>Access denied. Please log in.</div>,
}: LoginProtectedProps) => {
  return (
    <ProtectedComponent
      resource={RESOURCES.USER}
      action={USER_ACTIONS.LOGIN}
      children={children}
      fallback={fallback}
    />
  )
}

// Convenience component for contact info protection
interface ContactInfoProtectedProps {
  children: ReactNode
  fallback?: ReactNode
}

export const ContactInfoProtected = ({
  children,
  fallback = null,
}: ContactInfoProtectedProps) => {
  return (
    <ProtectedComponent
      resource={RESOURCES.STUDENT}
      action={USER_ACTIONS.VIEW_CONTACT_INFO}
      children={children}
      fallback={fallback}
    />
  )
}
